import { render, staticRenderFns } from "./UnidadesSidebar.vue?vue&type=template&id=b7e9c258&scoped=true&"
import script from "./UnidadesSidebar.vue?vue&type=script&lang=js&"
export * from "./UnidadesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e9c258",
  null
  
)

export default component.exports